import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getCourseProgram = payload => api.get('/platform/course-program', payload)

const getCourseProgramById = payload =>
  api.get(`/platform/course-program/spe/${payload.programId}`, payload)

const createCourseProgram = payload =>
  api.post(`/platform/course-program`, payload.data, { params: payload.params })

const editCourseProgram = payload =>
  api.put(`/platform/course-program`, payload.data, {
    params: payload.params,
  })

const editCourseProgramCourse = payload =>
  api.post(`/platform/course-program/courseTemp/${payload.programId}`, payload.data, {
    params: payload.params,
  })

const editProgramCourseOrder = payload =>
  api.put(`/platform/course-program/courseTemp/${payload.programId}`, payload.data, {
    params: payload.params,
  })

const deleteCourseProgram = payload =>
  api.delete(`/platform/course-program/${payload.programId}`, { params: payload.params })

const deleteCourseProgramCourse = payload =>
  api.delete(`/platform/course-program/courseTemp/${payload.programId}`, { params: payload.params })

export default {
  getCourseProgram,
  getCourseProgramById,
  createCourseProgram,
  editCourseProgram,
  editCourseProgramCourse,
  editProgramCourseOrder,
  deleteCourseProgram,
  deleteCourseProgramCourse,
}
